import { render, staticRenderFns } from "./QuizProgressBar.vue?vue&type=template&id=4ef9b25a&"
import script from "./QuizProgressBar.vue?vue&type=script&lang=js&"
export * from "./QuizProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports